import { render, staticRenderFns } from "./ProfitsMonth.vue?vue&type=template&id=1d886010&scoped=true"
import script from "./ProfitsMonth.vue?vue&type=script&lang=js"
export * from "./ProfitsMonth.vue?vue&type=script&lang=js"
import style0 from "./ProfitsMonth.vue?vue&type=style&index=0&id=1d886010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d886010",
  null
  
)

export default component.exports